import{isCustomValue}from'../../utils/resolve-value.mjs';import{isMotionValue}from'./is-motion-value.mjs';/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */function resolveMotionValue(value){var unwrappedValue=isMotionValue(value)?value.get():value;return isCustomValue(unwrappedValue)?unwrappedValue.toValue():unwrappedValue;}export{resolveMotionValue};